// Based on this directive:
// https://github.com/rbma/rbma-frontend/blob/dev/app/scripts/directives/blocktypes/video-block_directive.coffee

// Video widgets

const getAutoplay = block => {
  if (block.poster || block.autoplay) {
    return '1';
  }
  return '0';
};

const getBCPID = video => {
  return video.bcpid || '1890493041001';
};

const getHeight = element => {
  return Math.floor((element[0].clientWidth * 2) / 3);
};

const loadPlayer = (target, block) => {
  const video = block.service ? block : block.video;

  const embeds = {
    youtube: (videoID, playlistID) =>
      `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoID}?${playlistID}modestbranding=1;autohide=1;showinfo=0;rel=0;autoplay=${getAutoplay(
        block
      )}" frameborder="0" allowfullscreen></iframe>`,
    vimeo: videoID =>
      `<iframe src="//player.vimeo.com/video/${videoID}?color=ff0179&title=0&byline=0&portrait=0&badge=0&autoplay=${getAutoplay(
        block
      )}" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`,
    dailymotion: videoID =>
      `<iframe frameborder="0" width="480" height="270" src="//www.dailymotion.com/embed/video/${videoID}?autoplay=${getAutoplay(
        block
      )}" allowfullscreen></iframe>`,
    brightcove: videoID =>
      `<iframe frameborder="0" src="https://link.brightcove.com/services/player/bcpid${getBCPID(
        video
      )}?bctid=${videoID}&autoStart=${(!!parseInt(
        getAutoplay(block),
        10
      )).toString()}&height=${getHeight(target)}&width=${
        target[0].clientWidth
      }"></iframe>`,
  };

  const videoID = video.id;
  let playlistID = '';
  if (video.playlistID) {
    playlistID = `list=${video.playlistID}&`;
  }

  if (videoID) {
    const poster = target.querySelector('.video-frame__poster');
    if (poster) {
      poster.parentElement.innerHTML = embeds[video.service](
        videoID,
        playlistID
      );
    }
  }
};

export const initVideos = pageData => {
  pageData.videos.forEach(item => {
    const $videoContainer = document.querySelector(`#body-${item.blockN}`);
    if ($videoContainer) {
      $videoContainer.addEventListener('click', () => {
        loadPlayer($videoContainer, item);
      });
    }
  });

  if (pageData.video) {
    const $videoBlockContainer = document.querySelector(
      'rbma-video-block .video-frame'
    );
    $videoBlockContainer.on('click', () => {
      loadPlayer($videoBlockContainer, pageData.video);
    });
  }

  if (pageData.transcript) {
    pageData.transcript.forEach(item => {
      const $videoContainer = document.querySelector(
        `#transcript-${item.blockN}`
      );
      $videoContainer.on('click', () => {
        loadPlayer($videoContainer, item);
      });
    });
  }
};
